module.exports = __webpack_public_path__ + "static/media/KnowledgeTab1.5eb5dd65.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/KnowledgeTab1.png
// module id = 19
// module chunks = 0